var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDummyAvatar = function SvgDummyAvatar(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.332,
    cy: 26.139,
    fill: "#FFF",
    stroke: "#DFF7FF",
    rx: 26.332,
    ry: 26.139
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFF7FF",
    d: "M7 44.4a26.35 26.35 0 0 0 19.26 8.314 26.353 26.353 0 0 0 19.9-9.02A21.878 21.878 0 0 0 26.757 32 21.875 21.875 0 0 0 7 44.4zM25.943 29.687c4.94 0 8.943-8.907 8.943-13.81 0-4.902-4.004-8.877-8.943-8.877C21.003 7 17 10.975 17 15.877c0 4.903 4.004 13.81 8.943 13.81z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDummyAvatar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dummy-avatar.e9208b55cdab4d5cc068167a1f3c0402.svg";